export default __webpack_public_path__ + "media/images/fonts/materialdesignicons-webfont-380a87ac162f7313bdc7556fcca4fd38.woff2";